import * as React from "react";
import { useState, useEffect, useContext } from "react";
import AddCircle from "@mui/icons-material/AddCircle";
import EraseIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { GrupoEmail } from "../../components/classes/GrupoBroadcastEmail";
import GrupoEmailDataset from "../../components/data/GrupoBroadcastEmailDataSet";
import EmailBroadcast from "../../components/classes/EmailBroadcast";
import EmailDataset from "../../components/data/EmailBroadcastDataSet";
import { UserContext } from "../../App";
import Notification from "../../components/common/Notification";

import { useTranslation } from "react-i18next";

export default function GrupoEmailsModal(props: any) {
  const { t } = useTranslation();

  const { openDialog, setOpenDialog, grupoId } = props;
  const user: any = useContext(UserContext);

  const emailDataSet: EmailDataset = new EmailDataset();
  const grupoEmailDataset: GrupoEmailDataset = new GrupoEmailDataset();

  const [grupoEmail, setGrupoEmail] = useState<GrupoEmail[]>([]);
  const [rows, setRows] = useState<GrupoEmailRow[]>([]);
  const [openAddEmail, setOpenAddEmail] = useState<boolean>(false);
  const [emails, setEmails] = useState<EmailBroadcast[]>([]);
  const [emailsOptions, setEmailsOptions] = useState<AutocompleteOption[]>([]);
  const [inputEmail, setInputEmail] = React.useState<AutocompleteOption | null>(
    null
  );
  const [refresh, setRefresh] = useState<boolean>(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    if (refresh) {
      fetchGrupoEmails();
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    fetchGrupoEmails();
  }, [grupoId]);

  useEffect(() => {
    if (grupoEmail && grupoEmail.length > 0) {
      setRows((): GrupoEmailRow[] =>
        grupoEmail.map((item: GrupoEmail) => {
          return {
            id: item.grupoBroadcastEmailId,
            email: item.email,
          };
        })
      );
    } else {
      setRows([]);
    }
  }, [grupoEmail]);

  useEffect(() => {
    const emailCache: string = String(localStorage.getItem("EmailCache"));

    /* if (emailCache && emailCache !== 'null') {
             const emailParse: EmailBroadcast[] = JSON.parse(emailCache);
             if (emailParse) {
                 setEmails(emails);
             }
         } else {
             emailDataSet.ListarAtivos().then((result) => {
                 setEmails(result);
                 localStorage.setItem("EmailCache", JSON.stringify(result));
             });
         }*/

    emailDataSet.ListarAtivos().then((result) => {
      setEmails(result);
      localStorage.setItem("EmailCache", JSON.stringify(result));
    });
  }, []);

  const columns: GridColumns = [
    {
      field: "id",
      headerName: "#",
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "email",
      headerName: t("common.email"),
      width: 350,
      editable: false,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "deleteico",
      headerName: "",
      width: 50,
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Tooltip title={t("common.delete")}>
            <span>
              <IconButton
                disabled={user.isSuporte}
                onClick={(event) => {
                  handleClickDelete(event, cellValues);
                }}
              >
                <EraseIcon />
              </IconButton>
            </span>
          </Tooltip>
        );
      },
    },
  ];

  interface GrupoEmailRow {
    id: number;
    email: string;
  }

  interface AutocompleteOption {
    id: number;
    label: string;
  }

  const handleClickDelete = (_event: any, params: any) => {
    if (params?.id) {
      grupoEmailDataset.Desvincular(params.id).then((response) => {
        setNotify({
          isOpen: true,
          message: t("pages.emailsGroups.text.emailRemovedWithSuccess"),
          type: "success",
        });
        setRefresh(true);
      });
    }
  };

  const handleClickAdicionarEmailAoGrupo = () => {
    if (inputEmail) {
      adicionarEmail(inputEmail.id, inputEmail.label);
    }
    setOpenAddEmail(false);
  };

  function fetchGrupoEmails() {
    if (grupoId) {
      grupoEmailDataset.AllByGrupo(grupoId).then((result) => {
        setGrupoEmail(result);
      });
    } else {
      setGrupoEmail([]);
    }
  }

  function adicionarEmail(id: number, endereco: string) {
    grupoEmailDataset
      .Adicionar({
        id: 0,
        idEmailBroadcast: id,
        idGrupoBroadcast: grupoId,
        grupoBroadcast: [],
        emailBrodcast: [
          {
            id,
            endereco,
            criadoEm: new Date(),
            d_E_L_E_T_E: false,
            excluidoEm: new Date(),
          },
        ],
        criadoEm: new Date(),
        d_E_L_E_T_E: false,
        excluidoEm: new Date(),
      })
      .then((response) => {
        setNotify({
          isOpen: true,
          message: t("pages.emailsGroups.text.emailAddToGroupWithSuccess"),
          type: "success",
        });
        setRefresh(true);
      });
  }

  const handleClickOpenAddEmail = () => {
    setInputEmail(null);
    setEmailsOptions(emailToOption(emails));
    setOpenAddEmail(true);
  };

  function emailToOption(
    emailsList: EmailBroadcast[]
  ): React.SetStateAction<AutocompleteOption[]> {
    if (!emailsList || emailsList.length === 0) {
      emailsList = getEmailsListFromCache();
    }
    return emailsList
      ? emailsList
          .filter((f) => {
            const emailsArr = grupoEmail?.map((item) => item.emailId);
            return !emailsArr.includes(f.id);
          })
          .map((item) => {
            return {
              id: item.id,
              label: item.endereco,
            };
          })
      : [];
  }

  function getEmailsListFromCache(): EmailBroadcast[] {
    const emailCache: string = String(localStorage.getItem("EmailCache"));

    if (emailCache && emailCache !== "null") {
      const emailParse: EmailBroadcast[] = JSON.parse(emailCache);
      if (emailParse) {
        return JSON.parse(emailCache);
      }
    }
    return [];
  }

  return (
    <div>
      <div>
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          aria-labelledby="alert-dialog-title"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.emailsGroups.text.linkedEmails")}
          </DialogTitle>
          <DialogContent>
            <Box className="container">
              <Box className="containerToolbar">
                <Tooltip title={t("pages.emailsGroups.text.addEmail")}>
                  <IconButton onClick={handleClickOpenAddEmail}>
                    <AddCircle />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box
                className="gridScroll"
                sx={{ minWidth: "500px", height: "90vh" }}
              >
                <DataGrid
                  rows={rows}
                  columns={columns}
                  rowsPerPageOptions={[5, 10, 25]}
                  autoPageSize
                  disableSelectionOnClick
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenDialog(false)}
              autoFocus
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        <Dialog onClose={() => setOpenAddEmail(false)} open={openAddEmail}>
          <DialogTitle>{t("pages.emailsGroups.text.addEmail")}</DialogTitle>
          <DialogContent>
            <Autocomplete
              autoComplete
              id="autoCompleteEmails"
              options={emailsOptions}
              value={inputEmail}
              onChange={(_event: any, newValue: AutocompleteOption | null) => {
                setInputEmail(newValue);
              }}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("common.email")}
                  variant="standard"
                />
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="success"
              autoFocus
              onClick={() => handleClickAdicionarEmailAoGrupo()}
            >
              {t("common.add")}
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenAddEmail(false)}
              autoFocus
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
}
